module.exports = __webpack_public_path__ + "img/logo_lait.dfda867a.png";